/**
 * Database Cache Initializer Component
 * 
 * 🎯 PURPOSE: Initializes the database-driven cache system after AuthProvider is available
 * 
 * This component sits between AuthProvider and the rest of the app to avoid circular dependencies.
 * The useProjectsPagesDatabaseCache hook needs access to useAuth, so it can't be called 
 * inside the AuthProvider component itself.
 */

import React from 'react';
import { useProjectsPagesDatabaseCache } from '@/hooks/navigation/useProjectsPagesDatabaseCache';

interface DatabaseCacheInitializerProps {
  children: React.ReactNode;
}

export const DatabaseCacheInitializer: React.FC<DatabaseCacheInitializerProps> = ({ children }) => {
  // 🤖 AI CONTEXT: Initialize database-driven cache system
  // This replaces the fragmented React Query cache population hooks
  // Called here (after AuthProvider) to avoid circular dependency
  useProjectsPagesDatabaseCache();

  // This component is invisible - just initializes the cache and renders children
  return <>{children}</>;
}; 